// A regex to replace invalid characters with underscores
// for eventing.
const allowedPattern = new RegExp(/[^_A-Za-z0-9]/, 'g');

export const eventingTransform = (input: string): string => {
  return input.replace(allowedPattern, '_');
};
